module.exports = __webpack_public_path__ + "assets/img/kv-b0bcaa5b.jpg";